module.exports = __webpack_public_path__ + "static/media/mobile-banner.8c7dc3e2.png";